// openEHR BASE model — barrel for base.foundation_types
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

// Evaluation-order guard: these BMM packages import each other, so they must be
// entered in this order before anything else pulls one of them in.
import "./primitive_types.ts";
import "./foundation_types.ts";
import "./structure.ts";

export * from "./structure.ts";
export * from "./primitive_types.ts";
export * from "./foundation_types.ts";
export * from "./functional.ts";
export * from "./interval.ts";
export * from "./terminology.ts";
export * from "./time.ts";
